import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/ZR.png";
import masterApi from "../../services/masterApi";

const ForgotPassword = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (formData) => {
    try {
      const response = await masterApi.forgotPassword({ data: formData });

      if (response?.data?.ok) {
        setSuccess("Password reset email sent successfully.");
        setTimeout(() => {
          onReset(); // Navigate to login page
        }, 3000);
      } else {
        setError(response?.response?.data?.message || "Unexpected error occurred.");
      }
    } catch (err) {
      console.error("API Call Error:", err);
      setError(err.response?.data?.message || "Something went wrong!");
    }
  };

  const onReset = () => {
    navigate("../");
  };

  return (
    <div className="main-login-area">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>

        </div>
      </div>
      <div className="auth-page-content d-flex">
        <div className="container pt-5">
          <div className="justify-content-center row h-100 d-flex align-content-center pt-3">
            <div className="col-md-8 col-lg-5 col-xl-4 height-cls">
              <div className="card">
                <div className="p-4 card-body">
                  <div className="login-box">
                    <div className="login-content-area">
                      <div className="logo-area">
                      <div className="logo-box  d-flex flex-column justify-content-center align-items-center ">
                      <div className="logo-img text-center mb-4">
                            <img src={logo} alt="Logo" />
                          </div>
                          <h5 className="text-center mb-1">
                          Forgot Password

                          </h5>
                        </div>
                      </div>
                      <div className="login-input-area">
                        <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>
                          <div className="row">
                            <div className="col-12 col-md-12 mb-4 position-relative">
                              <label className="form-label" >
                                Email <span className="asterisk danger">*</span>
                              </label>
                              <input
                                {...register("email", { required: "Email is required" })}
                                className={`input ${errors.email ? "form-control required" : "form-control"}`}
                                type="email"
                                placeholder="Email Id"
                              />
                              {errors.email && <p className="error-message danger">{errors.email.message}</p>}
                            </div>


                          </div>


                          <div className="d-flex align-items-center gap-3">
                            <button
                              type="button"
                              className="btn btn-dark"
                              onClick={onReset}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-primary"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                        {error && <p className="error-message danger mb-0">{error}</p>}
                        {success && <p className="success-color mb-0">{success}</p>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ForgotPassword;